import { FC } from 'react';

import { Text } from '@lichtblick/photon/atoms/text/text';

import { CopyButton } from './copy-button';
import styles from './coupon-field.module.scss';

export const CouponField: FC<{ couponCode: string }> = ({ couponCode }) => (
  <div className={styles.field}>
    <Text>{couponCode}</Text>
    <CopyButton text={couponCode} />
  </div>
);
